var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeNormal = function SvgMeNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 56"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "me-normal_svg__a",
    d: "M0 0h60v60H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-6 -2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "me-normal_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#me-normal_svg__a"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 15,
    r: 12,
    stroke: "#111",
    strokeWidth: 2,
    mask: "url(#me-normal_svg__b)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 24,
    x: 7,
    y: 33,
    stroke: "#111",
    strokeWidth: 2,
    mask: "url(#me-normal_svg__b)",
    rx: 12
  }))));
};
export default SvgMeNormal;